import { IsBoolean, IsDefined, IsIn, IsInt, IsObject, IsOptional, IsString, Length, ValidateIf, isDefined, IsNotEmpty } from 'class-validator';

import { FieldLimiters } from '../../taxonomy/field-limiters/field-limiters';
import { NomenclatureTypeFieldType } from '../enum/nomenclature-type-field-type';
import { NomenclatureTypeField } from '../nomenclature-type-field';

export class NomenclatureTypeFieldUpdateRequest implements Partial<Omit<NomenclatureTypeField, 'isSystem' | 'fieldTitle' | 'fieldType'>> {
    /**
     * The nomenclature type field id. When absent (or falsy), the row is created instead of updated
     * (UPSERT parity with PHP actionUpdateNomenclatureTypeField).
     */
    @ValidateIf((o: NomenclatureTypeFieldUpdateRequest) => isDefined(o.id) || !isDefined(o.nomTypeUuid) || !isDefined(o.fieldName))
    @IsDefined({ message: '"id" is required when "nomTypeUuid" or "fieldName" is not set' })
    @IsInt()
    @IsNotEmpty()
    public id?: number;

    @ValidateIf((o: NomenclatureTypeFieldUpdateRequest) => isDefined(o.nomTypeUuid) || !isDefined(o.id))
    @IsDefined({ message: '"nomTypeUuid" is required when "id" is not set' })
    @IsString()
    @IsNotEmpty()
    @Length(36, 36)
    public nomTypeUuid?: string;

    @ValidateIf((o: NomenclatureTypeFieldUpdateRequest) => isDefined(o.fieldName) || !isDefined(o.id))
    @IsDefined({ message: '"fieldName" is required when "id" is not set' })
    @IsString()
    @IsNotEmpty()
    public fieldName?: string;

    @ValidateIf((o: NomenclatureTypeFieldUpdateRequest) => isDefined(o.type) || !isDefined(o.nomTypeUuid) || !isDefined(o.fieldName))
    @IsDefined({ message: '"type" is required when "nomTypeUuid" or "fieldName" is not set' })
    @IsIn([
        NomenclatureTypeFieldType.characteristic,
        NomenclatureTypeFieldType.parameter,
        NomenclatureTypeFieldType.group,
    ])
    public type: NomenclatureTypeFieldType;

    @IsOptional()
    @IsString()
    public name: string;

    @IsOptional()
    @IsString()
    public shortName: string;

    @IsOptional()
    @IsString()
    public tag: string;

    @IsOptional()
    @IsInt()
    public order: number;

    @IsOptional()
    @IsBoolean()
    public required: boolean;

    @IsOptional()
    @IsBoolean()
    public unique: boolean;

    @IsOptional()
    @IsBoolean()
    public printOnBill: boolean;

    @IsOptional()
    @IsBoolean()
    public printOnSticker: boolean;

    @IsOptional()
    @IsBoolean()
    public printFromNewSticker: boolean;

    @IsOptional()
    @IsObject()
    public limiters: Partial<FieldLimiters>;

    constructor(data?: Partial<NomenclatureTypeFieldUpdateRequest>) {
        this.id = data?.id;
        this.nomTypeUuid = data?.nomTypeUuid;
        this.fieldName = data?.fieldName;
        this.type = data?.type;
        this.name = data?.name;
        this.shortName = data?.shortName;
        this.tag = data?.tag;
        this.order = data?.order;
        this.required = data?.required;
        this.unique = data?.unique;
        this.printOnBill = data?.printOnBill;
        this.printOnSticker = data?.printOnSticker;
        this.printFromNewSticker = data?.printFromNewSticker;
        this.limiters = data?.limiters;
    }
}
